import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { ChevronRight } from '@wix/wix-ui-icons-common';
import React, { FC, useCallback, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { appRoutes } from '../../../react-router';
import { TLocalesKeys } from '../../../types';
import { biHelpCenter } from '../../../util/bi';
import s from '../styles.scss';
import { SectionComponentProps } from '../types';
import { helpCenterButtonDataHooks } from './HelpCenterButton.dataHooks';
import { HelpCenterIconSvg } from './HelpCenterIconSvg';

export const HelpCenterButton: FC<SectionComponentProps> = ({
  positionIndex,
  cta,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const categoriesLink = useMemo(
    () => ({
      pathname: cta
        ? appRoutes.categoryById({ categoryId: cta })
        : appRoutes.categories(),
      search: searchParams.toString(),
    }),
    [cta, searchParams],
  );

  const navigateToHelpCenter = useCallback(() => {
    biHelpCenter.logHelpCenterButtonInteraction(positionIndex);
    navigate(categoriesLink);
  }, [categoriesLink, navigate, positionIndex]);

  return (
    <div
      onClick={navigateToHelpCenter}
      data-hook={helpCenterButtonDataHooks.linkButton()}
    >
      <Box
        className={s.homepageActionItem}
        verticalAlign="middle"
        gap={3}
        padding="18px 6px 18px 18px"
        cursor="pointer"
      >
        <HelpCenterIconSvg />
        <Box direction="vertical">
          <Text size="small" secondary>
            {t<TLocalesKeys>('home_help_center_content')}
          </Text>
        </Box>
        <ChevronRight className={s.svgIcon} size="24" />
      </Box>
    </div>
  );
};
